module.exports = __webpack_public_path__ + "img/bonscheladen.a633b45f.jpg";